// Local Business Schema for Tennis Gourmet
export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "Restaurant",
  name: "Tennis Gourmet",
  alternateName: [
    "Ristorante Tennis & Gourmet",
    "Ristorante Morbegno Tennis Gourmet",
    "Tennis Gourmet Valtellina",
  ],
  description:
    "Ristorante Morbegno con piscina e padel in Valtellina. Cucina di pesce, pizzeria gourmet e centro sportivo con piscina nel cuore della Valtellina.",
  url: "https://www.ristorantetennisgourmet.it",
  telephone: "+39 0342 330685",
  email: "info@ristorantetennisgourmet.it",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Via Gregorini, 89",
    addressLocality: "Morbegno",
    addressRegion: "Lombardia",
    postalCode: "23017",
    addressCountry: "IT",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: "46.1364",
    longitude: "9.5708",
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
      opens: "09:00",
      closes: "23:00",
      description: "Bar",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: "Monday",
      opens: "12:00",
      closes: "14:30",
      description: "Cucina",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
      opens: "12:00",
      closes: "14:30",
      description: "Cucina - Pranzo",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
      opens: "19:00",
      closes: "22:00",
      description: "Cucina - Cena",
    },
  ],
  servesCuisine: ["Italian", "Seafood", "Pizza"],
  priceRange: "€€",
  image: [
    "https://www.ristorantetennisgourmet.it/images/home-hero.webp",
    "https://www.ristorantetennisgourmet.it/images/restaurant-hero.webp",
    "https://www.ristorantetennisgourmet.it/images/banner-external-restaurant.webp",
  ],
  logo: "https://www.ristorantetennisgourmet.it/images/tennis-logo.webp",
  sameAs: [
    // Add social media profiles when available
  ],
  amenityFeature: [
    {
      "@type": "LocationFeatureSpecification",
      name: "Tennis Court",
      value: true,
    },
    {
      "@type": "LocationFeatureSpecification",
      name: "Padel Court",
      value: true,
    },
    {
      "@type": "LocationFeatureSpecification",
      name: "Swimming Pool",
      value: true,
    },
    {
      "@type": "LocationFeatureSpecification",
      name: "Billiards",
      value: true,
    },
    {
      "@type": "LocationFeatureSpecification",
      name: "Outdoor Dining",
      value: true,
    },
    {
      "@type": "LocationFeatureSpecification",
      name: "Parking",
      value: true,
    },
  ],
  hasMenu: "https://www.ristorantetennisgourmet.it/restaurant#menu",
  keywords:
    "ristorante morbegno, ristorante valtellina, piscina morbegno, piscina valtellina, padel valtellina, tennis morbegno, pizzeria gourmet morbegno",
  areaServed: [
    {
      "@type": "City",
      name: "Morbegno",
    },
    {
      "@type": "AdministrativeArea",
      name: "Valtellina",
    },
    {
      "@type": "AdministrativeArea",
      name: "Provincia di Sondrio",
    },
  ],
};

// Organization Schema
export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Tennis Gourmet",
  url: "https://www.ristorantetennisgourmet.it",
  logo: "https://www.ristorantetennisgourmet.it/images/tennis-logo.webp",
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+39 0342 330685",
    contactType: "customer service",
    availableLanguage: "Italian",
  },
  address: {
    "@type": "PostalAddress",
    streetAddress: "Via Gregorini, 89",
    addressLocality: "Morbegno",
    addressRegion: "Lombardia",
    postalCode: "23017",
    addressCountry: "IT",
  },
};

// Sports Facility Schema
export const sportsFacilitySchema = {
  "@context": "https://schema.org",
  "@type": "SportsActivityLocation",
  name: "Tennis Gourmet - Centro Sportivo",
  alternateName: ["Centro Sportivo Morbegno", "Piscina Morbegno", "Padel Valtellina"],
  description:
    "Centro sportivo Morbegno con piscina, padel e tennis in Valtellina. Strutture moderne per sport e relax nel cuore della Valtellina.",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Via Gregorini, 89",
    addressLocality: "Morbegno",
    addressRegion: "Lombardia",
    postalCode: "23017",
    addressCountry: "IT",
  },
  sport: ["Tennis", "Padel", "Football", "Swimming"],
  amenityFeature: [
    {
      "@type": "LocationFeatureSpecification",
      name: "Tennis Court",
      value: true,
    },
    {
      "@type": "LocationFeatureSpecification",
      name: "Padel Court",
      value: true,
    },
    {
      "@type": "LocationFeatureSpecification",
      name: "Football Field",
      value: true,
    },
    {
      "@type": "LocationFeatureSpecification",
      name: "Swimming Pool",
      value: true,
    },
  ],
  keywords:
    "piscina morbegno, piscina valtellina, padel valtellina, tennis morbegno, centro sportivo valtellina, padel morbegno",
  areaServed: [
    {
      "@type": "City",
      name: "Morbegno",
    },
    {
      "@type": "AdministrativeArea",
      name: "Valtellina",
    },
    {
      "@type": "AdministrativeArea",
      name: "Provincia di Sondrio",
    },
  ],
};

// Breadcrumb Schema Generator
export const generateBreadcrumbSchema = (
  breadcrumbs: Array<{ name: string; url: string }>,
) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: breadcrumbs.map((crumb, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: crumb.name,
    item: crumb.url,
  })),
});

// FAQ Schema for local business
export const localBusinessFAQSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "Dove si trova il ristorante Tennis Gourmet?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Il ristorante Tennis Gourmet si trova a Morbegno, in Valtellina, precisamente in Via Gregorini 89, 23017 Morbegno (SO).",
      },
    },
    {
      "@type": "Question",
      name: "Che tipo di cucina offre il ristorante Morbegno?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Il nostro ristorante Morbegno è specializzato in cucina di pesce fresco e pizzeria gourmet, offrendo piatti creativi nel cuore della Valtellina.",
      },
    },
    {
      "@type": "Question",
      name: "Avete una piscina a Morbegno?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Sì, abbiamo una piscina Morbegno aperta durante la bella stagione, perfetta per rilassarsi dopo una cena o una partita di sport.",
      },
    },
    {
      "@type": "Question",
      name: "Offrite campi da padel in Valtellina?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Sì, il nostro centro sportivo offre campi da padel Valtellina moderni e ben mantenuti, insieme a campi da tennis e calcetto.",
      },
    },
  ],
};
